import { render, staticRenderFns } from "./IcoUpload.vue?vue&type=template&id=5e4f92ec&scoped=true"
import script from "./IcoUpload.vue?vue&type=script&lang=js"
export * from "./IcoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f92ec",
  null
  
)

export default component.exports